import { INavigationItem } from "@origin-digital/navigation-client-sdk";

export const helpLink: INavigationItem = {
  name: "help",
  title: "Help",
  icon: "IconHelpOutline",
  href: "/help-support",
};
